import React from 'react';
import './Header3.css';

const Header3 = () => {
  const scrollToStrategySession = () => {
    const element = document.getElementById('strategy-session');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="fullscreen-hero-wrapper">
      <div className="fullscreen-hero-container">
        {/* Background Image */}
        <div className="fh-background-layer">
          <picture>
            <source media="(max-width: 768px)" srcSet="/img/julian_mobile.webp" />
            <img src="/img/julian_10.webp" alt="Julian Propst" />
          </picture>
          <div className="fh-gradient-overlay"></div>
        </div>

        {/* Main Content - Left Side */}
        <div className="fh-main-content">
          <div className="fh-multipreneur">Proud to be part of BonusClub.io</div>
          <h1 className="fh-big-title">
            I Help Visionaries Build, Scale & Automate
          </h1>
         <h3 className="fh-title-highlight">Let me show you the excact strategies and tools to scale your business from zero to 6 figures.</h3>
         <button className="fh-primary-button" onClick={scrollToStrategySession}>
           Get Your Free Strategy Session
         </button>
        </div>

        {/* Mobile Image - Bottom Centered */}
        <div className="fh-event-card-wrapper">
          <p className="fh-event-badge">
            <span className="fh-pulse-dot">●</span> WORKING FOR: BONUSCLUB.IO
          </p>
          <div className="fh-event-thumbnail">
            <img src="/img/julian_mobile.webp" alt="Julian Propst" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header3;

